





































import { after } from '@noeldemartin/utils';
import Vue from 'vue';

interface Data {
    removeClickAwayListener: Function | null;
}

export interface MenuOption {
    text: string;
    icon?: string;
    handle(option: MenuOption): void;
}

export default Vue.extend({
    props: {
        options: {
            type: Array as () => MenuOption[],
            required: true,
        },
        direction: {
            type: String,
            default: 'top-left',
        },
    },
    data: (): Data => ({
        removeClickAwayListener: null,
    }),
    computed: {
        open(): boolean {
            return !!this.removeClickAwayListener;
        },
    },
    methods: {
        toggleMenu() {
            this.open ? this.closeMenu() : this.openMenu();
        },
        openMenu() {
            if (this.removeClickAwayListener)
                return;

            this.removeClickAwayListener = this.$ui.onClickAway(
                [
                    this.$refs.trigger as HTMLElement,
                    this.$refs.menu as HTMLElement,
                ],
                () => this.closeMenu(),
            );

            this.$emit('opened');
        },
        closeMenu() {
            if (!this.removeClickAwayListener)
                return;

            this.removeClickAwayListener();
            this.removeClickAwayListener = null;

            after({ milliseconds: 100 }).then(() => this.$emit('closed'));
        },
        triggerOption(option: MenuOption) {
            this.closeMenu();

            option.handle(option);
        },
    },
});
